import { Box, Typography, Grid, FormControl, InputLabel, Input, Button, TextField, FormHelperText } from '@mui/material'
import { useState } from 'react'
import { postCAfirm } from '../services/httpCalls'
import useNotify from "../utils/useNotify"

export default function CreateCaFirm() {
    const [caFirmForm, setCaFirmForm] = useState({
        name: "",
        caNotAssignedReminderWaitTime: 1,
        underProcessReminderWaitTime: 3,
        startHour: 10,
        stopHour: 19
    })
    const [loadingButton, setLoadingButton] = useState(false);
    const [errors, setErrors] = useState({
        name: false,
        underProcessReminderWaitTime:false,
        caNotAssignedReminderWaitTime:false,
        startHour:false, 
        stopHour: false
    })

    let notify = useNotify()
    const postCaFirmFunc = async (e) => {
        e.preventDefault()

        if(Object.values(errors).some(error => error === true)){
            return;
        }

        setLoadingButton(true)
        let data = caFirmForm
        await postCAfirm(data)
            .then((res) => {
                if (res) {
                    notify.success("Successfully created CA firm")
                    setCaFirmForm({
                        name: "",
                        caNotAssignedReminderWaitTime: 1,
                        underProcessReminderWaitTime: 3,
                        startHour: 10,
                        stopHour: 19
                    })
                }
                setLoadingButton(false)
            })
            .catch((err) => {
                if (err) {
                    notify.success("Not able to create CA firm")
                    setLoadingButton(false)
                }
            })
    }
    return (
        <Box sx={{ padding: "1rem" }}>
            <Typography variant="h5" sx={{ paddingBottom: "1rem", fontWeight: 400 }}>
                Create CA Firm
            </Typography>
            <Box component="form" validate onSubmit={(e) => postCaFirmFunc(e)}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                            error={errors.name}
                        >
                            <InputLabel htmlFor="name">CA Firm Name</InputLabel>
                            <Input
                                id="name"
                                inputProps={{ maxLength: 100 }}
                                sx={{ width: "100%" }}
                                value={caFirmForm["name"]}
                                onChange={(e) => {
                                    setCaFirmForm({ ...caFirmForm, [e.target.id]: e.target.value })
                                    if(e.target.value.length > 100){
                                        setErrors((error) => ({
                                            ...error,
                                            name:true
                                        }))
                                    } else {
                                        setErrors((error) => ({
                                            ...error,
                                            name:false
                                        }))
                                    }
                                }}
                                required={true}
                            />
                            {errors.name && <FormHelperText>Please enter a proper value!</FormHelperText>}
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                            error={errors.caNotAssignedReminderWaitTime}
                        >
                            <InputLabel htmlFor="caNotAssignedReminderWaitTime">CA not assigned waiting time</InputLabel>
                            <TextField
                                id="caNotAssignedReminderWaitTime"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={caFirmForm["caNotAssignedReminderWaitTime"]}
                                onChange={(e) => {
                                    setCaFirmForm({ ...caFirmForm, [e.target.id]: e.target.value })

                                    if(e.target.value < 1 || e.target.value > 10){
                                        setErrors((error) => ({
                                            ...error,
                                            caNotAssignedReminderWaitTime:true
                                        }))
                                    } else {
                                        setErrors((error) => ({
                                            ...error,
                                            caNotAssignedReminderWaitTime:false
                                        }))
                                    }
                                }}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 10, min: 1
                                    }
                                }}
                            />
                            {errors.caNotAssignedReminderWaitTime && <FormHelperText>Please enter a proper value!</FormHelperText>}
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                            error={errors.underProcessReminderWaitTime}
                        >
                            <InputLabel htmlFor="underProcessReminderWaitTime">Under process reminder wait time</InputLabel>
                            <TextField
                                id="underProcessReminderWaitTime"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={caFirmForm["underProcessReminderWaitTime"]}
                                onChange={(e) => {
                                    setCaFirmForm({ ...caFirmForm, [e.target.id]: e.target.value })

                                    if(e.target.value < 1 || e.target.value > 3){
                                        setErrors((error) => ({
                                            ...error,
                                            underProcessReminderWaitTime:true
                                        }))
                                    } else {
                                        setErrors((error) => ({
                                            ...error,
                                            underProcessReminderWaitTime:false
                                        }))
                                    }
                                }}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 3, min: 1
                                    }
                                }}
                            />
                            {errors.underProcessReminderWaitTime && <FormHelperText>Please enter a proper value!</FormHelperText>}                           
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                            error={errors.startHour}
                        >
                            <InputLabel htmlFor="startHour">Start Hour</InputLabel>
                            <TextField
                                id="startHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={caFirmForm["startHour"]}
                                onChange={(e) => {
                                    setCaFirmForm({ ...caFirmForm, [e.target.id]: e.target.value })
                                
                                    if(e.target.value < 0 || e.target.value > 23){
                                        setErrors((error) => ({
                                            ...error,
                                            startHour:true
                                        }))
                                    } else {
                                        setErrors((error) => ({
                                            ...error,
                                            startHour:false
                                        }))
                                    }
                                }}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 23, min: 0
                                    }
                                }}
                            />
                            {errors.startHour && <FormHelperText>Please enter a proper value!</FormHelperText>}                           
                        </FormControl>
                        <FormControl
                            variant="standard"
                            required
                            sx={{ width: "300px", display: "block", marginTop: ".5rem", paddingTop: '2.5rem' }}
                            error={errors.stopHour}
                        >
                            <InputLabel htmlFor="stopHour">Stop Hour</InputLabel>
                            <TextField
                                id="stopHour"
                                variant='standard'
                                sx={{ width: "100%" }}
                                value={caFirmForm["stopHour"]}
                                onChange={(e) => {
                                    setCaFirmForm({ ...caFirmForm, [e.target.id]: e.target.value })
                                
                                    if(e.target.value < 0 || e.target.value > 23){
                                        setErrors((error) => ({
                                            ...error,
                                            stopHour:true
                                        }))
                                    } else {
                                        setErrors((error) => ({
                                            ...error,
                                            stopHour:false
                                        }))
                                    }
                                    
                                }}
                                required={true}
                                type={'number'}
                                InputProps={{
                                    inputProps: {
                                        max: 23, min: 0
                                    }
                                }}
                            />
                         {errors.stopHour && <FormHelperText>Please enter a proper value!</FormHelperText>}                           
                        </FormControl>
                    </Grid>
                </Grid>
                <Button variant="contained" type={'submit'} sx={{ marginTop: '1.5rem' }} disabled={loadingButton}>Create CA Firm</Button>
            </Box>
        </Box>
    )
}